import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { getStatusToken, WORK_PLANS_ACCENT } from './workPlansTokens';

export interface WorkPlansStatusChipProps extends Omit<ChipProps, 'color'> {
  status: string;
  /** Filter chip inactive style */
  filterInactive?: boolean;
  /** Active filter — uses status palette */
  filterActive?: boolean;
}

export const WorkPlansStatusChip: React.FC<WorkPlansStatusChipProps> = ({
  status,
  filterInactive,
  filterActive,
  sx,
  ...rest
}) => {
  const t = getStatusToken(status);
  if (filterInactive) {
    return (
      <Chip
        size="small"
        sx={{
          bgcolor: '#ffffff',
          color: '#6B7280',
          border: '1.5px solid #E5E7EB',
          fontSize: '12px',
          fontWeight: 600,
          px: 0.25,
          '& .MuiChip-label': { px: 1.375 },
          ...sx,
        }}
        {...rest}
      />
    );
  }
  if (filterActive) {
    return (
      <Chip
        size="small"
        sx={{
          bgcolor: t.bg,
          color: t.text,
          border: `2px solid ${WORK_PLANS_ACCENT}`,
          fontSize: '12px',
          fontWeight: 600,
          px: 0.25,
          '& .MuiChip-label': { px: 1.375 },
          ...sx,
        }}
        {...rest}
      />
    );
  }
  return (
    <Chip
      size="small"
      sx={{
        bgcolor: t.bg,
        color: t.text,
        border: `1px solid ${t.border}`,
        fontSize: '12px',
        fontWeight: 600,
        ...sx,
      }}
      {...rest}
    />
  );
};
